import React from 'react';
import RoddoPageShell from './layout/RoddoPageShell';
import TournamentHubView from './tournaments/TournamentHubView';
import type {
  Tournament,
  TournamentPlatformConfig,
  UserProfile,
} from '../types';

type Props = {
  userProfile: UserProfile;
  tournaments: Record<string, Tournament>;
  config: TournamentPlatformConfig;
  onBack: () => void;
  addToast: (message: string, type?: any) => void;
  initialTournamentId?: string | null;
  onLogTournamentCatch: (tournament: Tournament) => void;
  onOpenUserProfile?: (userId: string, tournamentId?: string) => void;
  isDarkMode?: boolean;
};

export default function TournamentView({
  userProfile,
  tournaments,
  config,
  onBack,
  addToast,
  initialTournamentId,
  onLogTournamentCatch,
  onOpenUserProfile,
  isDarkMode = false,
}: Props) {
  return (
    <div
      data-roddo-tour="tournaments-page"
      className="h-full min-h-0 w-full touch-pan-y overflow-y-auto overscroll-contain [-webkit-overflow-scrolling:touch]"
      style={{
        WebkitOverflowScrolling: 'touch',
        overscrollBehaviorY: 'contain',
        scrollPaddingBottom: 'calc(var(--roddo-content-inset-bottom, 102px) + 28px)',
      }}
    >
      <RoddoPageShell
        allowParentScroll
        padding="sm"
        className="min-h-full overflow-visible"
        contentClassName="max-w-4xl lg:max-w-none pb-[calc(var(--roddo-content-inset-bottom,102px)+28px)] lg:pb-6"
      >
        <TournamentHubView
          userProfile={userProfile}
          tournaments={tournaments}
          config={config}
          addToast={addToast}
          initialTournamentId={initialTournamentId}
          onLogTournamentCatch={onLogTournamentCatch}
          onOpenUserProfile={onOpenUserProfile}
          onBack={onBack}
          isDarkMode={isDarkMode}
        />
      </RoddoPageShell>
    </div>
  );
}
